import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable, tap } from 'rxjs';
import { environment } from '../../../environments/environment';
import { User } from '../../shared/models/user.model';

export interface LoginCredentials {
  email: string;
  password: string;
}

export interface RegisterCredentials extends LoginCredentials {
  name: string;
}

export interface FacebookLoginResponse {
  accessToken: string;
  userID: string;
  name?: string;
  email?: string;
}

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  public currentUserSubject = new BehaviorSubject<User | null>(null);
  public currentUser$ = this.currentUserSubject.asObservable();
  
  // Replace with your actual API endpoint
  private baseUrl = `${environment.baseUrl}/api`;

  constructor(private http: HttpClient) {
    // Check if user is already logged in
    const storedUser = localStorage.getItem('user');
    if (storedUser) {
      this.currentUserSubject.next(JSON.parse(storedUser));
    }
  }

  initializeCSRF(): Observable<void> {
    return this.http.get<void>(`${environment.baseUrl}/sanctum/csrf-cookie`);
  }

  loginWithFacebook(): Observable<User> {
    // In a real application, you would integrate with the Facebook SDK
    // and handle the OAuth flow. For now, we'll simulate a successful login
    return this.http.get(`${this.baseUrl}/facebook/connect`)
      .pipe(
        tap((res: any) => {
          console.log(res);
          // localStorage.setItem('user', JSON.stringify(user));
          // this.currentUserSubject.next(user);
        })
      );
  }

  login(credentials: LoginCredentials): Observable<User> {
    return this.http.post<User>(`${this.baseUrl}/login`, credentials)
      .pipe(
        tap(user => {
          localStorage.setItem('user', JSON.stringify(user));
          this.currentUserSubject.next(user);
        })
      );
  }

  loginOnLocalDevelopment(): Observable<User> {
    return this.http.get(`${this.baseUrl}/development/login`)
      .pipe(
        tap((user: any) => {
          localStorage.setItem('user', JSON.stringify(user.data));
          window.localStorage.setItem('token', user.token);
          this.currentUserSubject.next(user.data);
        })
      );
  }

  register(credentials: RegisterCredentials): Observable<User> {
    return this.http.post<User>(`${this.baseUrl}/register`, credentials)
      .pipe(
        tap(user => {
          localStorage.setItem('user', JSON.stringify(user));
          this.currentUserSubject.next(user);
        })
      );
  }

  isAuthenticated(): boolean {
    return window.localStorage.getItem('user') ? true : false;
  }

  getToken(): string | null {
    return this.currentUserSubject.value?.token || null;
  }

  processFacebookToken(token: string): Observable<any> {
    return this.http.post(`${this.baseUrl}/auth/facebook/callback`, { token })
      .pipe(
        tap((response: any) => {
          if (response.token) {
            localStorage.setItem('token', response.token);
            this.currentUserSubject.next(response.user);
          }
        })
      );
  }

  getUserProfile() {
    return this.http.get(`${this.baseUrl}/me`)
  }

  logout() {
    return this.http.post(`${this.baseUrl}/logout`, {})
      .pipe(
        tap(() => {
          localStorage.removeItem('user');
          this.currentUserSubject.next(null);
        })
      );
  }
} 